// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern Mobile Weekly Bills Planner Styles */
:root {
  --primary-color: #6366f1;
  --primary-dark: #4f46e5;
  --primary-light: #818cf8;
  --secondary-color: #10b981;
  --danger-color: #ef4444;
  --warning-color: #f59e0b;
  --gray-50: #f9fafb;
  --gray-100: #f3f4f6;
  --gray-200: #e5e7eb;
  --gray-300: #d1d5db;
  --gray-400: #9ca3af;
  --gray-500: #6b7280;
  --gray-600: #4b5563;
  --gray-700: #374151;
  --gray-800: #1f2937;
  --gray-900: #111827;
  --white: #ffffff;
  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --shadow-xl: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --border-radius: 12px;
  --border-radius-lg: 16px;
  --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Dark Mode Variables */
.dark-mode {
  --primary-color: #818cf8;
  --primary-dark: #6366f1;
  --primary-light: #a5b4fc;
  --secondary-color: #34d399;
  --danger-color: #f87171;
  --warning-color: #fbbf24;
  --gray-50: #1f2937;
  --gray-100: #374151;
  --gray-200: #4b5563;
  --gray-300: #6b7280;
  --gray-400: #9ca3af;
  --gray-500: #d1d5db;
  --gray-600: #e5e7eb;
  --gray-700: #f3f4f6;
  --gray-800: #f9fafb;
  --gray-900: #ffffff;
  --white: #111827;
  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.3);
  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.3), 0 2px 4px -2px rgb(0 0 0 / 0.3);
  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.3), 0 4px 6px -4px rgb(0 0 0 / 0.3);
  --shadow-xl: 0 20px 25px -5px rgb(0 0 0 / 0.3), 0 8px 10px -6px rgb(0 0 0 / 0.3);
}

* {
  box-sizing: border-box;
}

.mobile-weekly-bills-planner {
  max-width: 100%;
  margin: 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'SF Pro Display', sans-serif;
  background: linear-gradient(135deg, var(--gray-50) 0%, var(--gray-100) 100%);
  min-height: 100vh;
  color: var(--gray-800);
  line-height: 1.6;
}

/* Mobile Header */
.mobile-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 72px;
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-shadow: var(--shadow-lg);
  z-index: 100;
  backdrop-filter: blur(20px);
}

.header-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.mobile-header h1 {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: var(--white);
  letter-spacing: -0.025em;
}

@media (max-width: 480px) {
  .mobile-header h1 {
    font-size: 20px;
  }
}

.save-status {
  font-size: 12px;
  font-weight: 500;
  padding: 2px 8px;
  border-radius: 12px;
  color: var(--white);
  transition: var(--transition);
  animation: fadeIn 0.3s ease-in-out;
}

.save-status.saving {
  background: rgba(59, 130, 246, 0.8);
}

.save-status.saved {
  background: rgba(34, 197, 94, 0.8);
}

.save-status.error {
  background: rgba(239, 68, 68, 0.8);
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.header-actions {
  display: flex;
  gap: 8px;
}

@media (max-width: 480px) {
  .header-actions {
    gap: 6px;
  }
}

.menu-button,
.action-button {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  font-size: 24px;
  padding: 12px;
  cursor: pointer;
  color: var(--white);
  border-radius: 12px;
  transition: var(--transition);
  backdrop-filter: blur(10px);
}

.menu-button:hover,
.action-button:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: scale(1.05);
}

.menu-button:active,
.action-button:active {
  transform: scale(0.95);
}

/* Mobile Menu */
.mobile-menu {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  z-index: 1000;
}

.menu-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
  z-index: 1001;
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.menu-content {
  position: relative;
  background: var(--white);
  padding: 32px 24px;
  width: 85%;
  max-width: 320px;
  margin-left: auto;
  z-index: 1002;
  height: 100%;
  overflow-y: auto;
  box-shadow: var(--shadow-xl);
  display: flex;
  flex-direction: column;
  gap: 20px;
  animation: slideInRight 0.3s ease-out;
}

@keyframes slideInRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.menu-content button {
  padding: 16px 20px;
  border: none;
  background: linear-gradient(135deg, var(--gray-50) 0%, var(--gray-100) 100%);
  border-radius: var(--border-radius);
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: var(--transition);
  color: var(--gray-700);
  box-shadow: var(--shadow-sm);
}

.menu-content button:hover {
  background: linear-gradient(135deg, var(--gray-100) 0%, var(--gray-200) 100%);
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.menu-content button:active {
  transform: translateY(0);
}

.menu-content .file-upload {
  margin: 0;
}

.menu-content .file-upload label {
  display: block;
  padding: 16px 20px;
  background: linear-gradient(135deg, var(--secondary-color) 0%, #059669 100%);
  border-radius: var(--border-radius);
  text-align: center;
  cursor: pointer;
  color: var(--white);
  font-weight: 600;
  transition: var(--transition);
  box-shadow: var(--shadow-sm);
}

.menu-content .file-upload label:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.menu-content .file-upload input[type="file"] {
  display: none;
}

.menu-content .payroll-input {
  padding: 20px;
  background: linear-gradient(135deg, var(--gray-50) 0%, var(--white) 100%);
  border-radius: var(--border-radius);
  border: 1px solid var(--gray-200);
}

.menu-content .payroll-input label {
  display: block;
  margin-bottom: 12px;
  font-weight: 600;
  color: var(--gray-700);
}

.menu-content .input-with-symbol {
  display: flex;
  align-items: center;
  background: var(--white);
  border-radius: 8px;
  border: 2px solid var(--gray-200);
  overflow: hidden;
  transition: var(--transition);
}

.menu-content .input-with-symbol:focus-within {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

.menu-content .input-with-symbol span {
  color: var(--gray-500);
  background: var(--gray-50);
  padding: 12px 16px;
  font-weight: 600;
}

.menu-content .input-with-symbol input {
  border: none;
  padding: 12px 16px;
  width: 100%;
  font-size: 16px;
  background: transparent;
  color: var(--gray-800);
}

.menu-content .input-with-symbol input:focus {
  outline: none;
}

/* Menu Responsive Styles */
@media (max-width: 768px) {
  .menu-content {
    width: 90%;
    max-width: 300px;
    padding: 28px 20px;
    gap: 16px;
  }
  
  .menu-content button {
    padding: 14px 16px;
    font-size: 15px;
  }
  
  .menu-content .payroll-input {
    padding: 16px;
  }
  
  .menu-content .input-with-symbol span {
    padding: 12px 14px;
    font-size: 15px;
  }
  
  .menu-content .input-with-symbol input {
    padding: 12px 14px;
    font-size: 15px;
  }
}

@media (max-width: 480px) {
  .menu-content {
    width: 85%;
    max-width: 280px;
    padding: 24px 16px;
    gap: 14px;
  }
  
  .menu-content button {
    padding: 12px 14px;
    font-size: 14px;
  }
  
  .menu-content .file-upload label {
    padding: 14px 16px;
    font-size: 15px;
  }
  
  .menu-content .payroll-input {
    padding: 14px;
  }
  
  .menu-content .payroll-input label {
    font-size: 15px;
    margin-bottom: 10px;
  }
  
  .menu-content .input-with-symbol span {
    padding: 10px 12px;
    font-size: 14px;
  }
  
  .menu-content .input-with-symbol input {
    padding: 10px 12px;
    font-size: 14px;
  }
}

.logout-button {
  margin-top: auto;
  background: linear-gradient(135deg, var(--danger-color) 0%, #dc2626 100%) !important;
  color: var(--white) !important;
  font-weight: 600;
}

.logout-button:hover {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%) !important;
}

.theme-toggle-button {
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%) !important;
  color: var(--white) !important;
  font-weight: 600;
}

.theme-toggle-button:hover {
  background: linear-gradient(135deg, var(--primary-dark) 0%, var(--primary-color) 100%) !important;
}

/* Week Summary */
.mobile-week-summary {
  margin-top: 88px;
  padding: 24px 20px;
  background: var(--white);
  margin-bottom: 16px;
  border-radius: 0 0 var(--border-radius-lg) var(--border-radius-lg);
  box-shadow: var(--shadow-md);
}

.week-header h2 {
  margin: 0 0 20px 0;
  font-size: 24px;
  font-weight: 800;
  color: var(--gray-800);
  text-align: center;
  letter-spacing: -0.025em;
}

@media (max-width: 768px) {
  .week-header h2 {
    font-size: 22px;
    margin-bottom: 16px;
  }
}

@media (max-width: 480px) {
  .week-header h2 {
    font-size: 20px;
    margin-bottom: 14px;
  }
}

.revenue-total {
  text-align: center;
  margin-bottom: 24px;
}

.revenue-total h3 {
  margin: 0;
  font-size: 32px;
  font-weight: 900;
  background: linear-gradient(135deg, var(--secondary-color) 0%, #059669 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -0.025em;
}

@media (max-width: 768px) {
  .revenue-total h3 {
    font-size: 28px;
  }
}

@media (max-width: 480px) {
  .revenue-total h3 {
    font-size: 24px;
  }
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.summary-item {
  background: linear-gradient(135deg, var(--gray-50) 0%, var(--white) 100%);
  padding: 20px;
  border-radius: var(--border-radius);
  border: 1px solid var(--gray-200);
  text-align: center;
  transition: var(--transition);
}

.summary-item:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.summary-item.final {
  grid-column: span 2;
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);
  color: var(--white);
  border: none;
}

.summary-item .label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  opacity: 0.7;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.summary-item .value {
  display: block;
  font-size: 20px;
  font-weight: 800;
  letter-spacing: -0.025em;
}

.summary-item.final .label,
.summary-item.final .value {
  color: var(--white);
}

/* Daily Breakdown */
.mobile-daily-breakdown {
  padding: 0 20px 100px 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.mobile-day-card {
  background: var(--white);
  border-radius: var(--border-radius-lg);
  overflow: hidden;
  box-shadow: var(--shadow-md);
  border: 1px solid var(--gray-200);
  transition: var(--transition);
}

.mobile-day-card:hover {
  box-shadow: var(--shadow-lg);
}

.mobile-day-header {
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  background: linear-gradient(135deg, var(--gray-50) 0%, var(--white) 100%);
  border-bottom: 1px solid var(--gray-200);
  transition: var(--transition);
}

.mobile-day-header:hover {
  background: linear-gradient(135deg, var(--gray-100) 0%, var(--gray-50) 100%);
}

.day-info h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: var(--gray-800);
  letter-spacing: -0.025em;
}

.day-info span {
  font-size: 14px;
  color: var(--gray-500);
  font-weight: 500;
}

.day-summary {
  text-align: right;
  display: flex;
  align-items: center;
  gap: 16px;
}

.day-summary .balance {
  font-size: 18px;
  font-weight: 800;
  color: var(--primary-color);
  letter-spacing: -0.025em;
}

.day-summary .expand-icon {
  font-size: 16px;
  color: var(--gray-400);
  transition: var(--transition);
}

.mobile-day-card.active .expand-icon {
  transform: rotate(180deg);
}

/* Day Card Content */
.mobile-day-content {
  padding: 24px;
  background: var(--white);
  animation: expandIn 0.3s ease-out;
}

@keyframes expandIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.mobile-day-section {
  margin-bottom: 28px;
}

.mobile-day-section:last-child {
  margin-bottom: 0;
}

.mobile-day-section h4 {
  margin: 0 0 16px 0;
  font-size: 16px;
  font-weight: 700;
  color: var(--gray-800);
  display: flex;
  align-items: center;
  gap: 8px;
}

.mobile-day-section h4::before {
  content: '';
  width: 4px;
  height: 16px;
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);
  border-radius: 2px;
}

.special-calculation {
  background: linear-gradient(135deg, var(--warning-color) 0%, #f59e0b 100%);
  padding: 20px;
  border-radius: var(--border-radius);
  color: var(--white);
  margin-bottom: 24px;
}

.special-calculation h4 {
  color: var(--white);
  margin-bottom: 16px;
}

.special-calculation h4::before {
  background: var(--white);
}

.calculation-breakdown,
.calc-summary {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.calc-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  font-size: 15px;
}

.calc-row.total {
  border-top: 2px solid rgba(255, 255, 255, 0.3);
  margin-top: 8px;
  padding-top: 16px;
  font-weight: 700;
  font-size: 16px;
}

.calc-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.3);
  margin: 8px 0;
}

/* Input Styles */
.mobile-input {
  width: 100%;
  padding: 16px 20px;
  border: 2px solid var(--gray-200);
  border-radius: var(--border-radius);
  font-size: 16px;
  background: var(--white);
  color: var(--gray-800);
  transition: var(--transition);
  font-weight: 500;
}

.mobile-input:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

.mobile-input.small {
  padding: 12px 16px;
  font-size: 14px;
}

/* Subsections */
.subsection {
  background: linear-gradient(135deg, var(--gray-50) 0%, var(--white) 100%);
  border-radius: var(--border-radius);
  padding: 20px;
  margin-bottom: 16px;
  border: 1px solid var(--gray-200);
}

.subsection-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  font-weight: 600;
  color: var(--gray-700);
}

.subsection-header span:last-child {
  font-weight: 800;
  color: var(--primary-color);
}

/* Bills and Purchases */
.bills-list,
.purchases-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.bill-item,
.purchase-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background: var(--white);
  border-radius: 8px;
  border: 1px solid var(--gray-200);
  transition: var(--transition);
}

.bill-item:hover,
.purchase-item:hover {
  box-shadow: var(--shadow-sm);
  border-color: var(--gray-300);
}

.bill-info,
.purchase-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1;
}

.bill-name,
.purchase-name {
  font-weight: 600;
  color: var(--gray-800);
  font-size: 14px;
}

.bill-amount,
.purchase-amount {
  font-weight: 700;
  color: var(--primary-color);
  font-size: 14px;
}

.bill-actions {
  display: flex;
  gap: 8px;
}

.bill-actions button,
.remove-button {
  padding: 8px 12px;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
}

.bill-actions button {
  background: var(--gray-100);
  color: var(--gray-700);
}

.bill-actions button:hover {
  background: var(--gray-200);
  transform: translateY(-1px);
}

.remove-button {
  background: var(--danger-color);
  color: var(--white);
}

.remove-button:hover {
  background: #dc2626;
  transform: translateY(-1px);
}

.add-button {
  width: 100%;
  padding: 12px 16px;
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);
  color: var(--white);
  border: none;
  border-radius: var(--border-radius);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: var(--transition);
  margin-top: 12px;
  text-align: center;
  line-height: 1.2;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.add-button:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.add-button:active {
  transform: translateY(0);
}

/* Revenue Controls */
.revenue-input {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.revenue-input label {
  font-weight: 600;
  color: var(--gray-700);
  min-width: 80px;
}

.profit-tax-controls {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: 20px 0;
}

.control-group {
  background: var(--white);
  padding: 20px;
  border-radius: var(--border-radius);
  border: 1px solid var(--gray-200);
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 500;
  color: var(--gray-700);
  cursor: pointer;
  margin-bottom: 12px;
}

.checkbox-label input[type="checkbox"] {
  width: 20px;
  height: 20px;
  accent-color: var(--primary-color);
}

.custom-input {
  padding-left: 32px;
}

.custom-input label {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 14px;
  color: var(--gray-600);
}

/* Final Balance Section */
.final-balance {
  background: linear-gradient(135deg, var(--secondary-color) 0%, #059669 100%);
  padding: 24px;
  border-radius: var(--border-radius);
  color: var(--white);
  text-align: center;
}

.final-balance .calc-row {
  justify-content: center;
  font-size: 20px;
  font-weight: 800;
  letter-spacing: -0.025em;
}

.final-balance .calc-row.large {
  font-size: 24px;
}

/* Mobile Dialog */
.mobile-dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease-out;
  padding: 16px;
  box-sizing: border-box;
}

.dialog-content {
  background: var(--white);
  width: 100%;
  max-width: 400px;
  border-radius: var(--border-radius-lg);
  padding: 32px 24px;
  box-shadow: var(--shadow-xl);
  animation: scaleIn 0.3s ease-out;
  max-height: calc(100vh - 32px);
  overflow-y: auto;
  position: relative;
}

@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.dialog-content h3 {
  margin: 0 0 24px 0;
  font-size: 20px;
  font-weight: 700;
  text-align: center;
  color: var(--gray-800);
}

.dialog-content input,
.dialog-content select {
  width: 100%;
  padding: 16px 20px;
  border: 2px solid var(--gray-200);
  border-radius: var(--border-radius);
  font-size: 16px;
  margin-bottom: 20px;
  background: var(--white);
  color: var(--gray-800);
  transition: var(--transition);
}

.dialog-content input:focus,
.dialog-content select:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

.dialog-buttons {
  display: flex;
  gap: 12px;
  margin-top: 24px;
}

.dialog-buttons button {
  flex: 1 1;
  padding: 16px 24px;
  border: none;
  border-radius: var(--border-radius);
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
}

.dialog-buttons button:first-child {
  background: var(--gray-100);
  color: var(--gray-700);
}

.dialog-buttons button:first-child:hover {
  background: var(--gray-200);
}

.dialog-buttons button:last-child {
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);
  color: var(--white);
}

.dialog-buttons button:last-child:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.dialog-buttons button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none !important;
}

/* Bills Manager Specific Styles */
.bills-manager {
  min-height: 400px;
  max-height: 80vh;
}

.bills-manager-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 2px solid var(--gray-200);
}

.bills-manager-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: var(--gray-800);
}

.bills-manager-header button {
  background: none;
  border: none;
  font-size: 24px;
  color: var(--gray-500);
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: var(--transition);
}

.bills-manager-header button:hover {
  background: var(--gray-100);
  color: var(--gray-700);
}

.bills-manager .bills-list {
  flex: 1 1;
  overflow-y: auto;
  max-height: calc(80vh - 120px);
  padding-right: 8px;
}

/* Print Section */
.mobile-print-section {
  padding: 24px 20px 120px 20px;
  text-align: center;
}

@media (max-width: 768px) {
  .mobile-print-section {
    padding: 20px 16px 100px 16px;
  }
}

@media (max-width: 480px) {
  .mobile-print-section {
    padding: 16px 12px 80px 12px;
  }
}

.print-button {
  background: linear-gradient(135deg, var(--gray-800) 0%, var(--gray-700) 100%);
  color: var(--white);
  border: none;
  padding: 16px 32px;
  border-radius: var(--border-radius);
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
  box-shadow: var(--shadow-md);
}

@media (max-width: 480px) {
  .print-button {
    padding: 14px 24px;
    font-size: 15px;
    width: 100%;
    max-width: 300px;
  }
}

.print-button:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

/* Debug Section */
.debug-section {
  margin: 24px 20px;
  padding: 24px;
  background: var(--gray-800);
  color: var(--white);
  border-radius: var(--border-radius);
  font-family: 'SF Mono', 'Monaco', 'Cascadia Code', monospace;
}

@media (max-width: 768px) {
  .debug-section {
    margin: 20px 16px;
    padding: 20px;
  }
}

@media (max-width: 480px) {
  .debug-section {
    margin: 16px 12px;
    padding: 16px;
  }
}

.debug-section h3 {
  margin: 0 0 20px 0;
  color: var(--white);
}

@media (max-width: 480px) {
  .debug-section h3 {
    font-size: 16px;
    margin-bottom: 16px;
  }
}

.debug-info {
  margin-bottom: 20px;
}

@media (max-width: 480px) {
  .debug-info {
    margin-bottom: 16px;
  }
}

.debug-info h4 {
  margin: 0 0 12px 0;
  color: var(--gray-300);
}

@media (max-width: 480px) {
  .debug-info h4 {
    font-size: 14px;
    margin-bottom: 10px;
  }
}

.debug-info button {
  margin: 4px;
  padding: 8px 12px;
  background: var(--primary-color);
  color: var(--white);
  border: none;
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
}

@media (max-width: 480px) {
  .debug-info button {
    margin: 3px;
    padding: 6px 10px;
    font-size: 11px;
  }
}

.debug-section pre {
  background: var(--gray-900);
  padding: 16px;
  border-radius: 8px;
  overflow-x: auto;
  font-size: 12px;
  line-height: 1.4;
}

@media (max-width: 480px) {
  .debug-section pre {
    padding: 12px;
    font-size: 11px;
    line-height: 1.3;
  }
}

/* Loading and Error States */
.loading-container,
.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 40px 20px;
  text-align: center;
}

@media (max-width: 480px) {
  .loading-container,
  .error-container {
    padding: 30px 16px;
  }
}

.loading-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid var(--gray-200);
  border-top: 4px solid var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 24px;
}

@media (max-width: 480px) {
  .loading-spinner {
    width: 40px;
    height: 40px;
    border-width: 3px;
    margin-bottom: 20px;
  }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-container p,
.error-container p {
  font-size: 16px;
  color: var(--gray-600);
  margin: 0;
}

@media (max-width: 480px) {
  .loading-container p,
  .error-container p {
    font-size: 14px;
  }
}

.error-container h1 {
  color: var(--danger-color);
  margin: 0 0 16px 0;
  font-size: 24px;
}

@media (max-width: 480px) {
  .error-container h1 {
    font-size: 20px;
    margin-bottom: 12px;
  }
}

/* Dialog Responsive Rules */
@media (max-width: 768px) {
  .mobile-dialog {
    padding: 12px;
  }
  
  .dialog-content {
    padding: 24px 16px;
  }
  
  .dialog-content h3 {
    font-size: 18px;
    margin-bottom: 20px;
  }
  
  .dialog-content input,
  .dialog-content select {
    padding: 14px 16px;
    font-size: 16px;
    margin-bottom: 16px;
  }
  
  .dialog-buttons {
    gap: 10px;
    margin-top: 20px;
  }
  
  .dialog-buttons button {
    padding: 14px 20px;
    font-size: 15px;
  }
}

@media (max-width: 480px) {
  .mobile-dialog {
    padding: 8px;
    align-items: flex-start;
    padding-top: 20px;
  }
  
  .dialog-content {
    padding: 20px 12px;
    max-height: calc(100vh - 40px);
    border-radius: 12px;
  }
  
  .dialog-content h3 {
    font-size: 16px;
    margin-bottom: 16px;
  }
  
  .dialog-content input,
  .dialog-content select {
    padding: 12px 14px;
    font-size: 16px;
    margin-bottom: 12px;
  }
  
  .dialog-buttons {
    gap: 8px;
    margin-top: 16px;
    flex-direction: column;
  }
  
  .dialog-buttons button {
    padding: 12px 16px;
    font-size: 14px;
    width: 100%;
  }

  /* Bills Manager Mobile Styles */
  .bills-manager {
    min-height: 300px;
    max-height: calc(100vh - 60px);
  }

  .bills-manager-header {
    margin-bottom: 16px;
    padding-bottom: 12px;
  }

  .bills-manager-header h3 {
    font-size: 18px;
  }

  .bills-manager-header button {
    font-size: 20px;
  }

  .bills-manager .bills-list {
    max-height: calc(100vh - 160px);
  }
}

/* Component Responsive Rules */
@media (max-width: 768px) {
  .mobile-week-summary {
    padding: 20px 16px;
  }
  
  .mobile-daily-breakdown {
    padding: 0 16px 100px 16px;
    gap: 12px;
  }
  
  .mobile-day-card {
    border-radius: 12px;
  }
  
  .mobile-day-content {
    padding: 20px;
  }
  
  .mobile-day-section {
    margin-bottom: 24px;
  }
  
  .mobile-input {
    padding: 14px 16px;
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .mobile-week-summary {
    padding: 16px 12px;
  }
  
  .summary-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  .summary-item.final {
    grid-column: span 1;
  }
  
  .summary-item {
    padding: 16px 12px;
  }
  
  .summary-item .value {
    font-size: 16px;
  }
  
  .summary-item .label {
    font-size: 11px;
  }
  
  .mobile-daily-breakdown {
    padding: 0 12px 100px 12px;
    gap: 10px;
  }
  
  .mobile-day-card {
    border-radius: 10px;
  }
  
  .mobile-day-header {
    padding: 16px 18px;
  }
  
  .day-info h3 {
    font-size: 16px;
  }
  
  .day-info span {
    font-size: 13px;
  }
  
  .day-summary .balance {
    font-size: 16px;
  }
  
  .mobile-day-content {
    padding: 16px 18px;
  }
  
  .mobile-day-section h4 {
    font-size: 15px;
    margin-bottom: 12px;
  }
  
  .mobile-input {
    padding: 12px 14px;
    font-size: 16px;
  }
  
  .mobile-input.small {
    padding: 10px 12px;
    font-size: 14px;
  }
  
  .subsection {
    padding: 16px;
    margin-bottom: 12px;
  }
  
  .subsection-header {
    margin-bottom: 12px;
    font-size: 14px;
  }
  
  .bill-item,
  .purchase-item {
    padding: 12px;
  }
  
  .bill-name,
  .purchase-name {
    font-size: 13px;
  }
  
  .bill-amount,
  .purchase-amount {
    font-size: 13px;
  }
  
  .bill-actions button,
  .remove-button {
    padding: 6px 10px;
    font-size: 11px;
  }
  
  .add-button {
    padding: 10px 12px;
    font-size: 12px;
    min-height: 40px;
  }
  
  .calc-row {
    font-size: 14px;
    padding: 8px 0;
  }
  
  .calc-row.total {
    font-size: 15px;
  }
  
  .special-calculation {
    padding: 16px;
    margin-bottom: 20px;
  }
  
  .final-balance {
    padding: 20px;
  }
  
  .final-balance .calc-row {
    font-size: 18px;
  }
  
  .final-balance .calc-row.large {
    font-size: 20px;
  }
  
  .revenue-input {
    gap: 8px;
    margin-bottom: 16px;
    flex-direction: column;
    align-items: flex-start;
  }
  
  .revenue-input label {
    min-width: auto;
    margin-bottom: 4px;
  }
  
  .profit-tax-controls {
    gap: 16px;
    margin: 16px 0;
  }
  
  .control-group {
    padding: 16px;
  }
  
  .checkbox-label {
    gap: 8px;
    margin-bottom: 8px;
    font-size: 14px;
  }
  
  .checkbox-label input[type="checkbox"] {
    width: 18px;
    height: 18px;
  }
  
  .custom-input {
    padding-left: 26px;
  }
  
  .custom-input label {
    font-size: 13px;
  }
}

/* Responsive Design */
@media (min-width: 768px) {
  .mobile-weekly-bills-planner {
    max-width: 768px;
    margin: 0 auto;
  }
  
  .mobile-header {
    max-width: 768px;
    left: 50%;
    transform: translateX(-50%);
  }
  
  .summary-grid {
    grid-template-columns: repeat(3, 1fr);
  }
  
  .summary-item.final {
    grid-column: span 3;
  }
}

@media (min-width: 1024px) {
  .mobile-daily-breakdown {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
}

/* Dark Mode Specific Adjustments */
.dark-mode .mobile-weekly-bills-planner {
  background: linear-gradient(135deg, var(--gray-50) 0%, var(--gray-100) 100%);
}

.dark-mode .mobile-header {
  background: linear-gradient(135deg, #422749 0%, #200f2a 100%);
  border-bottom: 1px solid var(--gray-200);
}

.dark-mode .mobile-header h1 {
  color: #ffffff;
}

.dark-mode .menu-button,
.dark-mode .action-button {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.dark-mode .menu-button:hover,
.dark-mode .action-button:hover {
  background: rgba(255, 255, 255, 0.1);
}

.dark-mode .mobile-week-summary {
  background: var(--white);
  border: 1px solid var(--gray-200);
}

.dark-mode .revenue-total h3 {
  background: linear-gradient(135deg, var(--secondary-color) 0%, #10b981 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.dark-mode .summary-item {
  background: linear-gradient(135deg, var(--gray-100) 0%, var(--white) 100%);
  border-color: var(--gray-200);
}

.dark-mode .summary-item.final {
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);
  color: var(--gray-900);
}

.dark-mode .mobile-day-card {
  background: var(--white);
  border-color: var(--gray-200);
}

.dark-mode .mobile-day-header {
  background: linear-gradient(135deg, var(--gray-100) 0%, var(--white) 100%);
  border-color: var(--gray-200);
}

.dark-mode .mobile-day-header:hover {
  background: linear-gradient(135deg, var(--gray-200) 0%, var(--gray-100) 100%);
}

.dark-mode .subsection {
  background: linear-gradient(135deg, var(--gray-100) 0%, var(--white) 100%);
  border-color: var(--gray-200);
}

.dark-mode .bill-item,
.dark-mode .purchase-item {
  background: var(--gray-50);
  border-color: var(--gray-200);
}

.dark-mode .bill-item:hover,
.dark-mode .purchase-item:hover {
  border-color: var(--gray-300);
}

.dark-mode .mobile-input {
  background: var(--gray-50);
  border-color: var(--gray-200);
  color: var(--gray-800);
}

.dark-mode .mobile-input:focus {
  border-color: var(--primary-color);
  background: var(--white);
}

.dark-mode .control-group {
  background: var(--gray-50);
  border-color: var(--gray-200);
}

.dark-mode .dialog-content {
  background: var(--white);
}

.dark-mode .dialog-content input,
.dark-mode .dialog-content select {
  background: var(--gray-50);
  border-color: var(--gray-200);
  color: var(--gray-800);
}

.dark-mode .dialog-content input:focus,
.dark-mode .dialog-content select:focus {
  background: var(--white);
  border-color: var(--primary-color);
}

.dark-mode .menu-content {
  background: var(--white);
}

.dark-mode .menu-content .input-with-symbol {
  background: var(--gray-50);
  border-color: var(--gray-200);
}

.dark-mode .menu-content .input-with-symbol:focus-within {
  background: var(--white);
}

.dark-mode .menu-content .input-with-symbol input {
  color: var(--gray-800);
}

.dark-mode .menu-content .payroll-input {
  background: linear-gradient(135deg, var(--gray-100) 0%, var(--gray-50) 100%);
  border-color: var(--gray-200);
}

/* Dark Mode Bills Manager */
.dark-mode .bills-manager-header {
  border-bottom-color: var(--gray-600);
}

.dark-mode .bills-manager-header h3 {
  color: var(--gray-100);
}

.dark-mode .bills-manager-header button {
  color: var(--gray-400);
}

.dark-mode .bills-manager-header button:hover {
  background: var(--gray-700);
  color: var(--gray-200);
}

/* Dark mode transitions */
.dark-mode * {
  transition: background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease;
}

/* Print Styles */
@media print {
  .mobile-header,
  .mobile-menu,
  .menu-button,
  .action-button,
  .add-button,
  .bill-actions,
  .remove-button,
  .mobile-print-section,
  .debug-section {
    display: none !important;
  }
  
  .mobile-weekly-bills-planner {
    background: var(--white);
    margin: 0;
    padding: 0;
  }
  
  .mobile-week-summary {
    margin-top: 0;
    box-shadow: none;
    border: 1px solid var(--gray-300);
  }
  
  .mobile-day-card {
    break-inside: avoid;
    page-break-inside: avoid;
    box-shadow: none;
    border: 1px solid var(--gray-300);
    margin-bottom: 20px;
  }
  
  .mobile-day-content {
    display: block !important;
  }
} `, "",{"version":3,"sources":["webpack://./src/styles/MobileWeeklyBillsPlanner.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;EACE,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,6EAA6E;EAC7E,+EAA+E;EAC/E,gFAAgF;EAChF,qBAAqB;EACrB,wBAAwB;EACxB,mDAAmD;AACrD;;AAEA,wBAAwB;AACxB;EACE,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,6EAA6E;EAC7E,+EAA+E;EAC/E,gFAAgF;AAClF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,gGAAgG;EAChG,4EAA4E;EAC5E,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,sFAAsF;EACtF,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,4BAA4B;EAC5B,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE;IACE,QAAQ;EACV;AACF;;AAEA;;EAEE,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;;EAEE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,4EAA4E;EAC5E,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,6EAA6E;EAC7E,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,4EAA4E;EAC5E,mCAAmC;EACnC,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yEAAyE;EACzE,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA,2BAA2B;AAC3B;EACE;IACE,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB,oFAAoF;EACpF,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,wEAAwE;AAC1E;;AAEA;EACE,iGAAiG;EACjG,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,iGAAiG;AACnG;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,kEAAkE;EAClE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,4EAA4E;EAC5E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,yEAAyE;EACzE,aAAa;EACb,mCAAmC;EACnC,iCAAiC;EACjC,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,sFAAsF;EACtF,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,sCAAsC;EACtC,gBAAgB;EAChB,4BAA4B;EAC5B,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,yEAAyE;EACzE,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA;EACE,4EAA4E;AAC9E;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,sFAAsF;EACtF,kBAAkB;AACpB;;AAEA;EACE,0EAA0E;EAC1E,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,8CAA8C;EAC9C,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,kBAAkB;EAClB,iCAAiC;EACjC,mCAAmC;EACnC,eAAe;EACf,wBAAwB;EACxB,sBAAsB;EACtB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,yEAAyE;EACzE,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,wBAAwB;EACxB,kBAAkB;EAClB,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;;EAEE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;AACT;;AAEA;;EAEE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sFAAsF;EACtF,mBAAmB;EACnB,YAAY;EACZ,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,4EAA4E;EAC5E,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;EAClB,4BAA4B;EAC5B,gCAAgC;EAChC,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,iCAAiC;EACjC,mCAAmC;EACnC,eAAe;EACf,mBAAmB;EACnB,wBAAwB;EACxB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sFAAsF;EACtF,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,kCAAkC;AAClC;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,6EAA6E;EAC7E,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,mCAAmC;EACnC,4DAA4D;AAC9D;;AAEA;EACE;IACE,iBAAiB;IACjB,aAAa;EACf;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE;IACE,WAAW;IACX,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,6BAA6B;AAC7B;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;;IAEE,kBAAkB;EACpB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,0CAA0C;EAC1C,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;;EAEE,eAAe;EACf,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,QAAQ;IACR,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;EACb;;EAEA,gCAAgC;EAChC;IACE,iBAAiB;IACjB,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA,+BAA+B;AAC/B;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;;IAEE,aAAa;EACf;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;IACR,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,SAAS;IACT,2BAA2B;EAC7B;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;EACX;AACF;;AAEA,mCAAmC;AACnC;EACE,4EAA4E;AAC9E;;AAEA;EACE,6DAA6D;EAC7D,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,4EAA4E;EAC5E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,0EAA0E;EAC1E,6BAA6B;AAC/B;;AAEA;EACE,sFAAsF;EACtF,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,0EAA0E;EAC1E,6BAA6B;AAC/B;;AAEA;EACE,6EAA6E;AAC/E;;AAEA;EACE,0EAA0E;EAC1E,6BAA6B;AAC/B;;AAEA;;EAEE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,0BAA0B;EAC1B,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;;EAEE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,4EAA4E;EAC5E,6BAA6B;AAC/B;;AAEA,4BAA4B;AAC5B;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,+EAA+E;AACjF;;AAEA,iBAAiB;AACjB;EACE;;;;;;;;;IASE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,mBAAmB;IACnB,wBAAwB;IACxB,gBAAgB;IAChB,iCAAiC;IACjC,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/* Modern Mobile Weekly Bills Planner Styles */\n:root {\n  --primary-color: #6366f1;\n  --primary-dark: #4f46e5;\n  --primary-light: #818cf8;\n  --secondary-color: #10b981;\n  --danger-color: #ef4444;\n  --warning-color: #f59e0b;\n  --gray-50: #f9fafb;\n  --gray-100: #f3f4f6;\n  --gray-200: #e5e7eb;\n  --gray-300: #d1d5db;\n  --gray-400: #9ca3af;\n  --gray-500: #6b7280;\n  --gray-600: #4b5563;\n  --gray-700: #374151;\n  --gray-800: #1f2937;\n  --gray-900: #111827;\n  --white: #ffffff;\n  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n  --shadow-xl: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\n  --border-radius: 12px;\n  --border-radius-lg: 16px;\n  --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Dark Mode Variables */\n.dark-mode {\n  --primary-color: #818cf8;\n  --primary-dark: #6366f1;\n  --primary-light: #a5b4fc;\n  --secondary-color: #34d399;\n  --danger-color: #f87171;\n  --warning-color: #fbbf24;\n  --gray-50: #1f2937;\n  --gray-100: #374151;\n  --gray-200: #4b5563;\n  --gray-300: #6b7280;\n  --gray-400: #9ca3af;\n  --gray-500: #d1d5db;\n  --gray-600: #e5e7eb;\n  --gray-700: #f3f4f6;\n  --gray-800: #f9fafb;\n  --gray-900: #ffffff;\n  --white: #111827;\n  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.3);\n  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.3), 0 2px 4px -2px rgb(0 0 0 / 0.3);\n  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.3), 0 4px 6px -4px rgb(0 0 0 / 0.3);\n  --shadow-xl: 0 20px 25px -5px rgb(0 0 0 / 0.3), 0 8px 10px -6px rgb(0 0 0 / 0.3);\n}\n\n* {\n  box-sizing: border-box;\n}\n\n.mobile-weekly-bills-planner {\n  max-width: 100%;\n  margin: 0;\n  padding: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'SF Pro Display', sans-serif;\n  background: linear-gradient(135deg, var(--gray-50) 0%, var(--gray-100) 100%);\n  min-height: 100vh;\n  color: var(--gray-800);\n  line-height: 1.6;\n}\n\n/* Mobile Header */\n.mobile-header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 72px;\n  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 20px;\n  box-shadow: var(--shadow-lg);\n  z-index: 100;\n  backdrop-filter: blur(20px);\n}\n\n.header-title {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n}\n\n.mobile-header h1 {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--white);\n  letter-spacing: -0.025em;\n}\n\n@media (max-width: 480px) {\n  .mobile-header h1 {\n    font-size: 20px;\n  }\n}\n\n.save-status {\n  font-size: 12px;\n  font-weight: 500;\n  padding: 2px 8px;\n  border-radius: 12px;\n  color: var(--white);\n  transition: var(--transition);\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n.save-status.saving {\n  background: rgba(59, 130, 246, 0.8);\n}\n\n.save-status.saved {\n  background: rgba(34, 197, 94, 0.8);\n}\n\n.save-status.error {\n  background: rgba(239, 68, 68, 0.8);\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.header-actions {\n  display: flex;\n  gap: 8px;\n}\n\n@media (max-width: 480px) {\n  .header-actions {\n    gap: 6px;\n  }\n}\n\n.menu-button,\n.action-button {\n  background: rgba(255, 255, 255, 0.1);\n  border: none;\n  font-size: 24px;\n  padding: 12px;\n  cursor: pointer;\n  color: var(--white);\n  border-radius: 12px;\n  transition: var(--transition);\n  backdrop-filter: blur(10px);\n}\n\n.menu-button:hover,\n.action-button:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: scale(1.05);\n}\n\n.menu-button:active,\n.action-button:active {\n  transform: scale(0.95);\n}\n\n/* Mobile Menu */\n.mobile-menu {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  z-index: 1000;\n}\n\n.menu-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(8px);\n  z-index: 1001;\n  animation: fadeIn 0.3s ease-out;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.menu-content {\n  position: relative;\n  background: var(--white);\n  padding: 32px 24px;\n  width: 85%;\n  max-width: 320px;\n  margin-left: auto;\n  z-index: 1002;\n  height: 100%;\n  overflow-y: auto;\n  box-shadow: var(--shadow-xl);\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  animation: slideInRight 0.3s ease-out;\n}\n\n@keyframes slideInRight {\n  from {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n.menu-content button {\n  padding: 16px 20px;\n  border: none;\n  background: linear-gradient(135deg, var(--gray-50) 0%, var(--gray-100) 100%);\n  border-radius: var(--border-radius);\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: var(--transition);\n  color: var(--gray-700);\n  box-shadow: var(--shadow-sm);\n}\n\n.menu-content button:hover {\n  background: linear-gradient(135deg, var(--gray-100) 0%, var(--gray-200) 100%);\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.menu-content button:active {\n  transform: translateY(0);\n}\n\n.menu-content .file-upload {\n  margin: 0;\n}\n\n.menu-content .file-upload label {\n  display: block;\n  padding: 16px 20px;\n  background: linear-gradient(135deg, var(--secondary-color) 0%, #059669 100%);\n  border-radius: var(--border-radius);\n  text-align: center;\n  cursor: pointer;\n  color: var(--white);\n  font-weight: 600;\n  transition: var(--transition);\n  box-shadow: var(--shadow-sm);\n}\n\n.menu-content .file-upload label:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.menu-content .file-upload input[type=\"file\"] {\n  display: none;\n}\n\n.menu-content .payroll-input {\n  padding: 20px;\n  background: linear-gradient(135deg, var(--gray-50) 0%, var(--white) 100%);\n  border-radius: var(--border-radius);\n  border: 1px solid var(--gray-200);\n}\n\n.menu-content .payroll-input label {\n  display: block;\n  margin-bottom: 12px;\n  font-weight: 600;\n  color: var(--gray-700);\n}\n\n.menu-content .input-with-symbol {\n  display: flex;\n  align-items: center;\n  background: var(--white);\n  border-radius: 8px;\n  border: 2px solid var(--gray-200);\n  overflow: hidden;\n  transition: var(--transition);\n}\n\n.menu-content .input-with-symbol:focus-within {\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);\n}\n\n.menu-content .input-with-symbol span {\n  color: var(--gray-500);\n  background: var(--gray-50);\n  padding: 12px 16px;\n  font-weight: 600;\n}\n\n.menu-content .input-with-symbol input {\n  border: none;\n  padding: 12px 16px;\n  width: 100%;\n  font-size: 16px;\n  background: transparent;\n  color: var(--gray-800);\n}\n\n.menu-content .input-with-symbol input:focus {\n  outline: none;\n}\n\n/* Menu Responsive Styles */\n@media (max-width: 768px) {\n  .menu-content {\n    width: 90%;\n    max-width: 300px;\n    padding: 28px 20px;\n    gap: 16px;\n  }\n  \n  .menu-content button {\n    padding: 14px 16px;\n    font-size: 15px;\n  }\n  \n  .menu-content .payroll-input {\n    padding: 16px;\n  }\n  \n  .menu-content .input-with-symbol span {\n    padding: 12px 14px;\n    font-size: 15px;\n  }\n  \n  .menu-content .input-with-symbol input {\n    padding: 12px 14px;\n    font-size: 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .menu-content {\n    width: 85%;\n    max-width: 280px;\n    padding: 24px 16px;\n    gap: 14px;\n  }\n  \n  .menu-content button {\n    padding: 12px 14px;\n    font-size: 14px;\n  }\n  \n  .menu-content .file-upload label {\n    padding: 14px 16px;\n    font-size: 15px;\n  }\n  \n  .menu-content .payroll-input {\n    padding: 14px;\n  }\n  \n  .menu-content .payroll-input label {\n    font-size: 15px;\n    margin-bottom: 10px;\n  }\n  \n  .menu-content .input-with-symbol span {\n    padding: 10px 12px;\n    font-size: 14px;\n  }\n  \n  .menu-content .input-with-symbol input {\n    padding: 10px 12px;\n    font-size: 14px;\n  }\n}\n\n.logout-button {\n  margin-top: auto;\n  background: linear-gradient(135deg, var(--danger-color) 0%, #dc2626 100%) !important;\n  color: var(--white) !important;\n  font-weight: 600;\n}\n\n.logout-button:hover {\n  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%) !important;\n}\n\n.theme-toggle-button {\n  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%) !important;\n  color: var(--white) !important;\n  font-weight: 600;\n}\n\n.theme-toggle-button:hover {\n  background: linear-gradient(135deg, var(--primary-dark) 0%, var(--primary-color) 100%) !important;\n}\n\n/* Week Summary */\n.mobile-week-summary {\n  margin-top: 88px;\n  padding: 24px 20px;\n  background: var(--white);\n  margin-bottom: 16px;\n  border-radius: 0 0 var(--border-radius-lg) var(--border-radius-lg);\n  box-shadow: var(--shadow-md);\n}\n\n.week-header h2 {\n  margin: 0 0 20px 0;\n  font-size: 24px;\n  font-weight: 800;\n  color: var(--gray-800);\n  text-align: center;\n  letter-spacing: -0.025em;\n}\n\n@media (max-width: 768px) {\n  .week-header h2 {\n    font-size: 22px;\n    margin-bottom: 16px;\n  }\n}\n\n@media (max-width: 480px) {\n  .week-header h2 {\n    font-size: 20px;\n    margin-bottom: 14px;\n  }\n}\n\n.revenue-total {\n  text-align: center;\n  margin-bottom: 24px;\n}\n\n.revenue-total h3 {\n  margin: 0;\n  font-size: 32px;\n  font-weight: 900;\n  background: linear-gradient(135deg, var(--secondary-color) 0%, #059669 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  letter-spacing: -0.025em;\n}\n\n@media (max-width: 768px) {\n  .revenue-total h3 {\n    font-size: 28px;\n  }\n}\n\n@media (max-width: 480px) {\n  .revenue-total h3 {\n    font-size: 24px;\n  }\n}\n\n.summary-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px;\n}\n\n.summary-item {\n  background: linear-gradient(135deg, var(--gray-50) 0%, var(--white) 100%);\n  padding: 20px;\n  border-radius: var(--border-radius);\n  border: 1px solid var(--gray-200);\n  text-align: center;\n  transition: var(--transition);\n}\n\n.summary-item:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.summary-item.final {\n  grid-column: span 2;\n  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);\n  color: var(--white);\n  border: none;\n}\n\n.summary-item .label {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  opacity: 0.7;\n  margin-bottom: 8px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.summary-item .value {\n  display: block;\n  font-size: 20px;\n  font-weight: 800;\n  letter-spacing: -0.025em;\n}\n\n.summary-item.final .label,\n.summary-item.final .value {\n  color: var(--white);\n}\n\n/* Daily Breakdown */\n.mobile-daily-breakdown {\n  padding: 0 20px 100px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.mobile-day-card {\n  background: var(--white);\n  border-radius: var(--border-radius-lg);\n  overflow: hidden;\n  box-shadow: var(--shadow-md);\n  border: 1px solid var(--gray-200);\n  transition: var(--transition);\n}\n\n.mobile-day-card:hover {\n  box-shadow: var(--shadow-lg);\n}\n\n.mobile-day-header {\n  padding: 20px 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  background: linear-gradient(135deg, var(--gray-50) 0%, var(--white) 100%);\n  border-bottom: 1px solid var(--gray-200);\n  transition: var(--transition);\n}\n\n.mobile-day-header:hover {\n  background: linear-gradient(135deg, var(--gray-100) 0%, var(--gray-50) 100%);\n}\n\n.day-info h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--gray-800);\n  letter-spacing: -0.025em;\n}\n\n.day-info span {\n  font-size: 14px;\n  color: var(--gray-500);\n  font-weight: 500;\n}\n\n.day-summary {\n  text-align: right;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.day-summary .balance {\n  font-size: 18px;\n  font-weight: 800;\n  color: var(--primary-color);\n  letter-spacing: -0.025em;\n}\n\n.day-summary .expand-icon {\n  font-size: 16px;\n  color: var(--gray-400);\n  transition: var(--transition);\n}\n\n.mobile-day-card.active .expand-icon {\n  transform: rotate(180deg);\n}\n\n/* Day Card Content */\n.mobile-day-content {\n  padding: 24px;\n  background: var(--white);\n  animation: expandIn 0.3s ease-out;\n}\n\n@keyframes expandIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.mobile-day-section {\n  margin-bottom: 28px;\n}\n\n.mobile-day-section:last-child {\n  margin-bottom: 0;\n}\n\n.mobile-day-section h4 {\n  margin: 0 0 16px 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--gray-800);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.mobile-day-section h4::before {\n  content: '';\n  width: 4px;\n  height: 16px;\n  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);\n  border-radius: 2px;\n}\n\n.special-calculation {\n  background: linear-gradient(135deg, var(--warning-color) 0%, #f59e0b 100%);\n  padding: 20px;\n  border-radius: var(--border-radius);\n  color: var(--white);\n  margin-bottom: 24px;\n}\n\n.special-calculation h4 {\n  color: var(--white);\n  margin-bottom: 16px;\n}\n\n.special-calculation h4::before {\n  background: var(--white);\n}\n\n.calculation-breakdown,\n.calc-summary {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.calc-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 0;\n  font-size: 15px;\n}\n\n.calc-row.total {\n  border-top: 2px solid rgba(255, 255, 255, 0.3);\n  margin-top: 8px;\n  padding-top: 16px;\n  font-weight: 700;\n  font-size: 16px;\n}\n\n.calc-divider {\n  height: 1px;\n  background: rgba(255, 255, 255, 0.3);\n  margin: 8px 0;\n}\n\n/* Input Styles */\n.mobile-input {\n  width: 100%;\n  padding: 16px 20px;\n  border: 2px solid var(--gray-200);\n  border-radius: var(--border-radius);\n  font-size: 16px;\n  background: var(--white);\n  color: var(--gray-800);\n  transition: var(--transition);\n  font-weight: 500;\n}\n\n.mobile-input:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);\n}\n\n.mobile-input.small {\n  padding: 12px 16px;\n  font-size: 14px;\n}\n\n/* Subsections */\n.subsection {\n  background: linear-gradient(135deg, var(--gray-50) 0%, var(--white) 100%);\n  border-radius: var(--border-radius);\n  padding: 20px;\n  margin-bottom: 16px;\n  border: 1px solid var(--gray-200);\n}\n\n.subsection-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n  font-weight: 600;\n  color: var(--gray-700);\n}\n\n.subsection-header span:last-child {\n  font-weight: 800;\n  color: var(--primary-color);\n}\n\n/* Bills and Purchases */\n.bills-list,\n.purchases-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.bill-item,\n.purchase-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px;\n  background: var(--white);\n  border-radius: 8px;\n  border: 1px solid var(--gray-200);\n  transition: var(--transition);\n}\n\n.bill-item:hover,\n.purchase-item:hover {\n  box-shadow: var(--shadow-sm);\n  border-color: var(--gray-300);\n}\n\n.bill-info,\n.purchase-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex: 1;\n}\n\n.bill-name,\n.purchase-name {\n  font-weight: 600;\n  color: var(--gray-800);\n  font-size: 14px;\n}\n\n.bill-amount,\n.purchase-amount {\n  font-weight: 700;\n  color: var(--primary-color);\n  font-size: 14px;\n}\n\n.bill-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.bill-actions button,\n.remove-button {\n  padding: 8px 12px;\n  border: none;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.bill-actions button {\n  background: var(--gray-100);\n  color: var(--gray-700);\n}\n\n.bill-actions button:hover {\n  background: var(--gray-200);\n  transform: translateY(-1px);\n}\n\n.remove-button {\n  background: var(--danger-color);\n  color: var(--white);\n}\n\n.remove-button:hover {\n  background: #dc2626;\n  transform: translateY(-1px);\n}\n\n.add-button {\n  width: 100%;\n  padding: 12px 16px;\n  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);\n  color: var(--white);\n  border: none;\n  border-radius: var(--border-radius);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: var(--transition);\n  margin-top: 12px;\n  text-align: center;\n  line-height: 1.2;\n  min-height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.add-button:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.add-button:active {\n  transform: translateY(0);\n}\n\n/* Revenue Controls */\n.revenue-input {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.revenue-input label {\n  font-weight: 600;\n  color: var(--gray-700);\n  min-width: 80px;\n}\n\n.profit-tax-controls {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin: 20px 0;\n}\n\n.control-group {\n  background: var(--white);\n  padding: 20px;\n  border-radius: var(--border-radius);\n  border: 1px solid var(--gray-200);\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-weight: 500;\n  color: var(--gray-700);\n  cursor: pointer;\n  margin-bottom: 12px;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n  accent-color: var(--primary-color);\n}\n\n.custom-input {\n  padding-left: 32px;\n}\n\n.custom-input label {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  font-size: 14px;\n  color: var(--gray-600);\n}\n\n/* Final Balance Section */\n.final-balance {\n  background: linear-gradient(135deg, var(--secondary-color) 0%, #059669 100%);\n  padding: 24px;\n  border-radius: var(--border-radius);\n  color: var(--white);\n  text-align: center;\n}\n\n.final-balance .calc-row {\n  justify-content: center;\n  font-size: 20px;\n  font-weight: 800;\n  letter-spacing: -0.025em;\n}\n\n.final-balance .calc-row.large {\n  font-size: 24px;\n}\n\n/* Mobile Dialog */\n.mobile-dialog {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  animation: fadeIn 0.3s ease-out;\n  padding: 16px;\n  box-sizing: border-box;\n}\n\n.dialog-content {\n  background: var(--white);\n  width: 100%;\n  max-width: 400px;\n  border-radius: var(--border-radius-lg);\n  padding: 32px 24px;\n  box-shadow: var(--shadow-xl);\n  animation: scaleIn 0.3s ease-out;\n  max-height: calc(100vh - 32px);\n  overflow-y: auto;\n  position: relative;\n}\n\n@keyframes scaleIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.dialog-content h3 {\n  margin: 0 0 24px 0;\n  font-size: 20px;\n  font-weight: 700;\n  text-align: center;\n  color: var(--gray-800);\n}\n\n.dialog-content input,\n.dialog-content select {\n  width: 100%;\n  padding: 16px 20px;\n  border: 2px solid var(--gray-200);\n  border-radius: var(--border-radius);\n  font-size: 16px;\n  margin-bottom: 20px;\n  background: var(--white);\n  color: var(--gray-800);\n  transition: var(--transition);\n}\n\n.dialog-content input:focus,\n.dialog-content select:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);\n}\n\n.dialog-buttons {\n  display: flex;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.dialog-buttons button {\n  flex: 1;\n  padding: 16px 24px;\n  border: none;\n  border-radius: var(--border-radius);\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.dialog-buttons button:first-child {\n  background: var(--gray-100);\n  color: var(--gray-700);\n}\n\n.dialog-buttons button:first-child:hover {\n  background: var(--gray-200);\n}\n\n.dialog-buttons button:last-child {\n  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);\n  color: var(--white);\n}\n\n.dialog-buttons button:last-child:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.dialog-buttons button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none !important;\n}\n\n/* Bills Manager Specific Styles */\n.bills-manager {\n  min-height: 400px;\n  max-height: 80vh;\n}\n\n.bills-manager-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding-bottom: 16px;\n  border-bottom: 2px solid var(--gray-200);\n}\n\n.bills-manager-header h3 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--gray-800);\n}\n\n.bills-manager-header button {\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: var(--gray-500);\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: var(--transition);\n}\n\n.bills-manager-header button:hover {\n  background: var(--gray-100);\n  color: var(--gray-700);\n}\n\n.bills-manager .bills-list {\n  flex: 1;\n  overflow-y: auto;\n  max-height: calc(80vh - 120px);\n  padding-right: 8px;\n}\n\n/* Print Section */\n.mobile-print-section {\n  padding: 24px 20px 120px 20px;\n  text-align: center;\n}\n\n@media (max-width: 768px) {\n  .mobile-print-section {\n    padding: 20px 16px 100px 16px;\n  }\n}\n\n@media (max-width: 480px) {\n  .mobile-print-section {\n    padding: 16px 12px 80px 12px;\n  }\n}\n\n.print-button {\n  background: linear-gradient(135deg, var(--gray-800) 0%, var(--gray-700) 100%);\n  color: var(--white);\n  border: none;\n  padding: 16px 32px;\n  border-radius: var(--border-radius);\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition);\n  box-shadow: var(--shadow-md);\n}\n\n@media (max-width: 480px) {\n  .print-button {\n    padding: 14px 24px;\n    font-size: 15px;\n    width: 100%;\n    max-width: 300px;\n  }\n}\n\n.print-button:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n}\n\n/* Debug Section */\n.debug-section {\n  margin: 24px 20px;\n  padding: 24px;\n  background: var(--gray-800);\n  color: var(--white);\n  border-radius: var(--border-radius);\n  font-family: 'SF Mono', 'Monaco', 'Cascadia Code', monospace;\n}\n\n@media (max-width: 768px) {\n  .debug-section {\n    margin: 20px 16px;\n    padding: 20px;\n  }\n}\n\n@media (max-width: 480px) {\n  .debug-section {\n    margin: 16px 12px;\n    padding: 16px;\n  }\n}\n\n.debug-section h3 {\n  margin: 0 0 20px 0;\n  color: var(--white);\n}\n\n@media (max-width: 480px) {\n  .debug-section h3 {\n    font-size: 16px;\n    margin-bottom: 16px;\n  }\n}\n\n.debug-info {\n  margin-bottom: 20px;\n}\n\n@media (max-width: 480px) {\n  .debug-info {\n    margin-bottom: 16px;\n  }\n}\n\n.debug-info h4 {\n  margin: 0 0 12px 0;\n  color: var(--gray-300);\n}\n\n@media (max-width: 480px) {\n  .debug-info h4 {\n    font-size: 14px;\n    margin-bottom: 10px;\n  }\n}\n\n.debug-info button {\n  margin: 4px;\n  padding: 8px 12px;\n  background: var(--primary-color);\n  color: var(--white);\n  border: none;\n  border-radius: 6px;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n@media (max-width: 480px) {\n  .debug-info button {\n    margin: 3px;\n    padding: 6px 10px;\n    font-size: 11px;\n  }\n}\n\n.debug-section pre {\n  background: var(--gray-900);\n  padding: 16px;\n  border-radius: 8px;\n  overflow-x: auto;\n  font-size: 12px;\n  line-height: 1.4;\n}\n\n@media (max-width: 480px) {\n  .debug-section pre {\n    padding: 12px;\n    font-size: 11px;\n    line-height: 1.3;\n  }\n}\n\n/* Loading and Error States */\n.loading-container,\n.error-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  padding: 40px 20px;\n  text-align: center;\n}\n\n@media (max-width: 480px) {\n  .loading-container,\n  .error-container {\n    padding: 30px 16px;\n  }\n}\n\n.loading-spinner {\n  width: 48px;\n  height: 48px;\n  border: 4px solid var(--gray-200);\n  border-top: 4px solid var(--primary-color);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 24px;\n}\n\n@media (max-width: 480px) {\n  .loading-spinner {\n    width: 40px;\n    height: 40px;\n    border-width: 3px;\n    margin-bottom: 20px;\n  }\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.loading-container p,\n.error-container p {\n  font-size: 16px;\n  color: var(--gray-600);\n  margin: 0;\n}\n\n@media (max-width: 480px) {\n  .loading-container p,\n  .error-container p {\n    font-size: 14px;\n  }\n}\n\n.error-container h1 {\n  color: var(--danger-color);\n  margin: 0 0 16px 0;\n  font-size: 24px;\n}\n\n@media (max-width: 480px) {\n  .error-container h1 {\n    font-size: 20px;\n    margin-bottom: 12px;\n  }\n}\n\n/* Dialog Responsive Rules */\n@media (max-width: 768px) {\n  .mobile-dialog {\n    padding: 12px;\n  }\n  \n  .dialog-content {\n    padding: 24px 16px;\n  }\n  \n  .dialog-content h3 {\n    font-size: 18px;\n    margin-bottom: 20px;\n  }\n  \n  .dialog-content input,\n  .dialog-content select {\n    padding: 14px 16px;\n    font-size: 16px;\n    margin-bottom: 16px;\n  }\n  \n  .dialog-buttons {\n    gap: 10px;\n    margin-top: 20px;\n  }\n  \n  .dialog-buttons button {\n    padding: 14px 20px;\n    font-size: 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .mobile-dialog {\n    padding: 8px;\n    align-items: flex-start;\n    padding-top: 20px;\n  }\n  \n  .dialog-content {\n    padding: 20px 12px;\n    max-height: calc(100vh - 40px);\n    border-radius: 12px;\n  }\n  \n  .dialog-content h3 {\n    font-size: 16px;\n    margin-bottom: 16px;\n  }\n  \n  .dialog-content input,\n  .dialog-content select {\n    padding: 12px 14px;\n    font-size: 16px;\n    margin-bottom: 12px;\n  }\n  \n  .dialog-buttons {\n    gap: 8px;\n    margin-top: 16px;\n    flex-direction: column;\n  }\n  \n  .dialog-buttons button {\n    padding: 12px 16px;\n    font-size: 14px;\n    width: 100%;\n  }\n\n  /* Bills Manager Mobile Styles */\n  .bills-manager {\n    min-height: 300px;\n    max-height: calc(100vh - 60px);\n  }\n\n  .bills-manager-header {\n    margin-bottom: 16px;\n    padding-bottom: 12px;\n  }\n\n  .bills-manager-header h3 {\n    font-size: 18px;\n  }\n\n  .bills-manager-header button {\n    font-size: 20px;\n  }\n\n  .bills-manager .bills-list {\n    max-height: calc(100vh - 160px);\n  }\n}\n\n/* Component Responsive Rules */\n@media (max-width: 768px) {\n  .mobile-week-summary {\n    padding: 20px 16px;\n  }\n  \n  .mobile-daily-breakdown {\n    padding: 0 16px 100px 16px;\n    gap: 12px;\n  }\n  \n  .mobile-day-card {\n    border-radius: 12px;\n  }\n  \n  .mobile-day-content {\n    padding: 20px;\n  }\n  \n  .mobile-day-section {\n    margin-bottom: 24px;\n  }\n  \n  .mobile-input {\n    padding: 14px 16px;\n    font-size: 16px;\n  }\n}\n\n@media (max-width: 480px) {\n  .mobile-week-summary {\n    padding: 16px 12px;\n  }\n  \n  .summary-grid {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n  \n  .summary-item.final {\n    grid-column: span 1;\n  }\n  \n  .summary-item {\n    padding: 16px 12px;\n  }\n  \n  .summary-item .value {\n    font-size: 16px;\n  }\n  \n  .summary-item .label {\n    font-size: 11px;\n  }\n  \n  .mobile-daily-breakdown {\n    padding: 0 12px 100px 12px;\n    gap: 10px;\n  }\n  \n  .mobile-day-card {\n    border-radius: 10px;\n  }\n  \n  .mobile-day-header {\n    padding: 16px 18px;\n  }\n  \n  .day-info h3 {\n    font-size: 16px;\n  }\n  \n  .day-info span {\n    font-size: 13px;\n  }\n  \n  .day-summary .balance {\n    font-size: 16px;\n  }\n  \n  .mobile-day-content {\n    padding: 16px 18px;\n  }\n  \n  .mobile-day-section h4 {\n    font-size: 15px;\n    margin-bottom: 12px;\n  }\n  \n  .mobile-input {\n    padding: 12px 14px;\n    font-size: 16px;\n  }\n  \n  .mobile-input.small {\n    padding: 10px 12px;\n    font-size: 14px;\n  }\n  \n  .subsection {\n    padding: 16px;\n    margin-bottom: 12px;\n  }\n  \n  .subsection-header {\n    margin-bottom: 12px;\n    font-size: 14px;\n  }\n  \n  .bill-item,\n  .purchase-item {\n    padding: 12px;\n  }\n  \n  .bill-name,\n  .purchase-name {\n    font-size: 13px;\n  }\n  \n  .bill-amount,\n  .purchase-amount {\n    font-size: 13px;\n  }\n  \n  .bill-actions button,\n  .remove-button {\n    padding: 6px 10px;\n    font-size: 11px;\n  }\n  \n  .add-button {\n    padding: 10px 12px;\n    font-size: 12px;\n    min-height: 40px;\n  }\n  \n  .calc-row {\n    font-size: 14px;\n    padding: 8px 0;\n  }\n  \n  .calc-row.total {\n    font-size: 15px;\n  }\n  \n  .special-calculation {\n    padding: 16px;\n    margin-bottom: 20px;\n  }\n  \n  .final-balance {\n    padding: 20px;\n  }\n  \n  .final-balance .calc-row {\n    font-size: 18px;\n  }\n  \n  .final-balance .calc-row.large {\n    font-size: 20px;\n  }\n  \n  .revenue-input {\n    gap: 8px;\n    margin-bottom: 16px;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .revenue-input label {\n    min-width: auto;\n    margin-bottom: 4px;\n  }\n  \n  .profit-tax-controls {\n    gap: 16px;\n    margin: 16px 0;\n  }\n  \n  .control-group {\n    padding: 16px;\n  }\n  \n  .checkbox-label {\n    gap: 8px;\n    margin-bottom: 8px;\n    font-size: 14px;\n  }\n  \n  .checkbox-label input[type=\"checkbox\"] {\n    width: 18px;\n    height: 18px;\n  }\n  \n  .custom-input {\n    padding-left: 26px;\n  }\n  \n  .custom-input label {\n    font-size: 13px;\n  }\n}\n\n/* Responsive Design */\n@media (min-width: 768px) {\n  .mobile-weekly-bills-planner {\n    max-width: 768px;\n    margin: 0 auto;\n  }\n  \n  .mobile-header {\n    max-width: 768px;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n  \n  .summary-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  \n  .summary-item.final {\n    grid-column: span 3;\n  }\n}\n\n@media (min-width: 1024px) {\n  .mobile-daily-breakdown {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 20px;\n  }\n}\n\n/* Dark Mode Specific Adjustments */\n.dark-mode .mobile-weekly-bills-planner {\n  background: linear-gradient(135deg, var(--gray-50) 0%, var(--gray-100) 100%);\n}\n\n.dark-mode .mobile-header {\n  background: linear-gradient(135deg, #422749 0%, #200f2a 100%);\n  border-bottom: 1px solid var(--gray-200);\n}\n\n.dark-mode .mobile-header h1 {\n  color: #ffffff;\n}\n\n.dark-mode .menu-button,\n.dark-mode .action-button {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.dark-mode .menu-button:hover,\n.dark-mode .action-button:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.dark-mode .mobile-week-summary {\n  background: var(--white);\n  border: 1px solid var(--gray-200);\n}\n\n.dark-mode .revenue-total h3 {\n  background: linear-gradient(135deg, var(--secondary-color) 0%, #10b981 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.dark-mode .summary-item {\n  background: linear-gradient(135deg, var(--gray-100) 0%, var(--white) 100%);\n  border-color: var(--gray-200);\n}\n\n.dark-mode .summary-item.final {\n  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);\n  color: var(--gray-900);\n}\n\n.dark-mode .mobile-day-card {\n  background: var(--white);\n  border-color: var(--gray-200);\n}\n\n.dark-mode .mobile-day-header {\n  background: linear-gradient(135deg, var(--gray-100) 0%, var(--white) 100%);\n  border-color: var(--gray-200);\n}\n\n.dark-mode .mobile-day-header:hover {\n  background: linear-gradient(135deg, var(--gray-200) 0%, var(--gray-100) 100%);\n}\n\n.dark-mode .subsection {\n  background: linear-gradient(135deg, var(--gray-100) 0%, var(--white) 100%);\n  border-color: var(--gray-200);\n}\n\n.dark-mode .bill-item,\n.dark-mode .purchase-item {\n  background: var(--gray-50);\n  border-color: var(--gray-200);\n}\n\n.dark-mode .bill-item:hover,\n.dark-mode .purchase-item:hover {\n  border-color: var(--gray-300);\n}\n\n.dark-mode .mobile-input {\n  background: var(--gray-50);\n  border-color: var(--gray-200);\n  color: var(--gray-800);\n}\n\n.dark-mode .mobile-input:focus {\n  border-color: var(--primary-color);\n  background: var(--white);\n}\n\n.dark-mode .control-group {\n  background: var(--gray-50);\n  border-color: var(--gray-200);\n}\n\n.dark-mode .dialog-content {\n  background: var(--white);\n}\n\n.dark-mode .dialog-content input,\n.dark-mode .dialog-content select {\n  background: var(--gray-50);\n  border-color: var(--gray-200);\n  color: var(--gray-800);\n}\n\n.dark-mode .dialog-content input:focus,\n.dark-mode .dialog-content select:focus {\n  background: var(--white);\n  border-color: var(--primary-color);\n}\n\n.dark-mode .menu-content {\n  background: var(--white);\n}\n\n.dark-mode .menu-content .input-with-symbol {\n  background: var(--gray-50);\n  border-color: var(--gray-200);\n}\n\n.dark-mode .menu-content .input-with-symbol:focus-within {\n  background: var(--white);\n}\n\n.dark-mode .menu-content .input-with-symbol input {\n  color: var(--gray-800);\n}\n\n.dark-mode .menu-content .payroll-input {\n  background: linear-gradient(135deg, var(--gray-100) 0%, var(--gray-50) 100%);\n  border-color: var(--gray-200);\n}\n\n/* Dark Mode Bills Manager */\n.dark-mode .bills-manager-header {\n  border-bottom-color: var(--gray-600);\n}\n\n.dark-mode .bills-manager-header h3 {\n  color: var(--gray-100);\n}\n\n.dark-mode .bills-manager-header button {\n  color: var(--gray-400);\n}\n\n.dark-mode .bills-manager-header button:hover {\n  background: var(--gray-700);\n  color: var(--gray-200);\n}\n\n/* Dark mode transitions */\n.dark-mode * {\n  transition: background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease;\n}\n\n/* Print Styles */\n@media print {\n  .mobile-header,\n  .mobile-menu,\n  .menu-button,\n  .action-button,\n  .add-button,\n  .bill-actions,\n  .remove-button,\n  .mobile-print-section,\n  .debug-section {\n    display: none !important;\n  }\n  \n  .mobile-weekly-bills-planner {\n    background: var(--white);\n    margin: 0;\n    padding: 0;\n  }\n  \n  .mobile-week-summary {\n    margin-top: 0;\n    box-shadow: none;\n    border: 1px solid var(--gray-300);\n  }\n  \n  .mobile-day-card {\n    break-inside: avoid;\n    page-break-inside: avoid;\n    box-shadow: none;\n    border: 1px solid var(--gray-300);\n    margin-bottom: 20px;\n  }\n  \n  .mobile-day-content {\n    display: block !important;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
